import React, { FunctionComponent, useRef, useState } from "react";

import { BiMale } from "@react-icons/all-files/bi/BiMale";
import { VennChart, ReportH4, ChartBodyWrapper } from "../../../Common";
import { IGPSBenchmarkCommonData } from "../../../../Models/Models";
import { DigitalShareItemType } from "../../../../Enums/DigitalShareItemType";
import { RenderType } from "../../../../Enums/RenderType";
import { DigitalShareAppType } from "../../../../Enums/DigitalShareAppType";
import { featureFlags } from "../../../../Common/CurrentFeatureFlags";
import {
    isOutputSelected,
    registerElement,
    registerRef,
} from "../../../Common/DigitalShare/DigitalShareGenerator";
import { VisitorLoyaltySharing } from "./VisitorLoyaltySharing";

interface VisitorLoyaltyProps {
  location1Name: string;
  location2Name?: string;
  benchmarkCommonData?: IGPSBenchmarkCommonData;
  scrollableParentSelector: string;
  renderType?: RenderType;
  app?: DigitalShareAppType;
  itemType?: DigitalShareItemType;
}

export const VisitorLoyalty: FunctionComponent<VisitorLoyaltyProps> = (
    props: VisitorLoyaltyProps
) => {
    const ref = useRef<HTMLDivElement>(null);
    const [vennActive, setVennActive] = useState<boolean>(false);
    const { location1Name, location2Name, benchmarkCommonData } = props;
    let percent1 = 0;
    let percent2 = 0;
    let centralPercent = 0;
    benchmarkCommonData.visitorLoyalty.forEach((loyaltyData, i) => {
        const roundedValue = Math.round(loyaltyData.value * 100) / 100;
        if (loyaltyData.jobIds.length > 1) {
            centralPercent = roundedValue;
        } else if (percent1 === 0) {
            percent1 = roundedValue;
        } else {
            percent2 = roundedValue;
        }
    });

    const afterAnimateIn = () => {
        setVennActive(true);
    };

    const renderType
    = props.renderType === undefined ? RenderType.DEFAULT : props.renderType;

    const chartText = `Shows % of visitors observed at ${location1Name} only, % observed at ${location2Name} only, and % observed at both places.`;

    const Chart = (
        <>
            <VennChart
                percent1={percent1}
                percent2={percent2}
                centralIcon={<BiMale />}
                centralPercent={centralPercent}
                location1Name={location1Name}
                location2Name={location2Name}
                isActive={vennActive}
            />
        </>
    );

    if (
        featureFlags.DigitalShare
    && props.renderType === RenderType.DIGITAL_SHARE
    && isOutputSelected(props.app, DigitalShareItemType.VisitorLoyalty)
    ) {
        registerRef(props.app, DigitalShareItemType.VisitorLoyalty, ref);
        registerElement(
            props.app,
            DigitalShareItemType.VisitorLoyalty,
            "",
            <VisitorLoyaltySharing
                benchmarkCommonData={props.benchmarkCommonData}
                polygons={[location1Name, location2Name]}
            />
        );
    }

    return (
        <>
            <ReportH4 style={{ lineHeight: "normal", marginTop: "75px" }}>
        Visitor Loyalty
            </ReportH4>
            <p style={{ fontSize: "17px" }}>{chartText}</p>
            <ChartBodyWrapper
                scrollableParentSelector={props.scrollableParentSelector}
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                afterAnimatedIn={afterAnimateIn}
                backgroundColor={"white"}
                style={{ padding: "26px" }}
            >
                {Chart}
            </ChartBodyWrapper>
        </>
    );
};
